// Generated by tools/tokens/extract.py from the mockup stylesheet.
// Do not edit by hand: change tools/mockups/build.py and regenerate.
// CI fails if this file does not match what the generator produces.
export const colors = {
    acornInk: '#936717',
    amberInk: '#8E6A00',
    bg: '#F7F4EE',
    card: '#FFFFFF',
    flame: '#E8843C',
    flameInk: '#A55E2B',
    gold: '#F2B705',
    goldInk: '#967103',
    green: '#44833B',
    greenD: '#31682A',
    greenInk: '#3A7B31',
    ink: '#2E2A26',
    line: '#E6DFD2',
    muted: '#7C7466',
    mutedInk: '#776F62',
    navy: '#2B3A67',
    navy2: '#43569A',
    purple: '#8A63C4',
    readingBg: '#FBF5E6',
    sky: '#E8EFFA',
};
/** Font sizes in points, as the mockups render them. */
export const fontSize = {
    h1: 27,
    h2: 20,
    h3: 15.5,
    body: 14.5,
    sub: 14,
    tiny: 12,
    kicker: 10.5,
};
export const radius = {
    button: 17,
    card: 20,
    chip: 12,
    bubble: 17,
};
/** The reference viewport the mockups are drawn at. */
export const referenceViewport = { width: 390, height: 844 };
//# sourceMappingURL=generated.js.map